import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset window scroll on route changes (SPA default is to keep scroll position). */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Hash routes (e.g. case studies anchors) handle their own scroll target.
    if (hash) return;

    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
